<template>
  <BaseModal
    v-model="state.open"
    :title="state.title"
    :closable="state.closable"
    layout="modal"
    :placement="state.placement || 'center'"
  >
    <template #default>
      <p class="mb-0">{{ state.message }}</p>
    </template>

    <template #footer>
      <button class="btn btn-outline-secondary" @click="onCancel">
        {{ state.cancelText || "Cancelar" }}
      </button>
      <button
        class="btn ms-2"
        :class="state.confirmClass || 'btn-primary'"
        @click="onConfirm"
        autofocus
      >
        {{ state.confirmText || "Aceptar" }}
      </button>
    </template>
  </BaseModal>
</template>

<script setup>
import BaseModal from "./BaseModal.vue";
import {
  confirmState as state,
  resolveConfirm,
} from "@/composables/useConfirm";
const onConfirm = () => resolveConfirm(true);
const onCancel = () => resolveConfirm(false);
</script>
